<template>
  <div>
    <div class="box-header">
      <h3 class="box-title title">Monitoreo de Servicio</h3>
    </div>
    <div class="box box-success">
      <div class="box-body">
        <div>
        <div class="">
          <div class="row">
            <div class="col-md-4">
              <!--<label>Cuenta</label>
                <select id="divClientSelect" v-model="selectedClient" class="form-control client">
                  <option v-for="client in this.userClients" v-bind:key="client.code" v-bind:value="client.code">
                    {{ client.name }}
                  </option>
                </select>-->
                <div id="divDashAccountSelect" class="form-group">
                  <label>Cuenta</label>
                  <multiselect
                    :value="this.dashboardFilter.client"
                    selectLabel=""
                    selectedLabel=""
                    deselectLabel=""
                    track-by="name"
                    :placeholder="this.dashboardFilter.client.name"
                    :allow-empty="false"
                    label="name"
                    :options="optionsAccount"
                    @input="onAccountSelect">
                    <span slot="noResult">
                      No se encontraron resultados
                    </span>
                  </multiselect>
                  </div>
                </div>
            <div v-if="window.width > 950" class="col-md-4">
              <div class="form-group">
                <label>Período</label>
                <div  id="divModeButtons" class="btn-group">
                  <button v-bind:class="getClass('today')" @click="onModeSelect('today')">Hoy</button>
                  <button v-bind:class="getClass('week')" @click="onModeSelect('week')"><span class="segundo-btn">Semana</span></button>
                  <button v-bind:class="getClass('month')" @click="onModeSelect('month')">Mes</button>
                  <button v-bind:class="getClass('date')" @click="onModeSelect('date')">Fecha</button>
                </div>
              </div>
            </div>
            <div class="col-md-4" v-bind:style="this.dashboardFilter.mode === 'date' ? 'display:block;' : 'display:none;'">
            <label for="dtDocEndDate">Desde - Hasta</label>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-addon">
                    <i class="icon-calendar"></i>
                  </div>
                  <input id="dtDateRange" mode="text" class="form-control">
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
       <div v-if="window.width < 950">
              <div class="form-group">
                <label>Período</label>
                <div  id="divModeButtons" class="btn-group">
                  <button v-bind:class="getClass('today')" @click="onModeSelect('today')">Hoy</button>
                  <button v-bind:class="getClass('week')" @click="onModeSelect('week')"><span class="segundo-btn">Semana</span></button>
                  <button v-bind:class="getClass('month')" @click="onModeSelect('month')">Mes</button>
                  <button v-bind:class="getClass('date')" @click="onModeSelect('date')">Fecha</button>
                </div>
              </div>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from 'assets/js/constants.js'
import { mapGetters, mapActions } from 'vuex'
import 'bootstrap-daterangepicker/daterangepicker.css'
import 'bootstrap-daterangepicker/daterangepicker.js'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment/moment.js'

export default {
  data () {
    return {
      optionsAccount: null,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  name: 'DashboardFilter',
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters([
      'dashboardFilter',
      'userClients'
    ])
  },
  created () {
    this.optionsAccount = Array.from(this.userClients)
  },
  mounted: function () {
    $(this.$el).find('#dtDateRange').daterangepicker({
      startDate: this.dashboardFilter.startDateFmt,
      endDate: this.dashboardFilter.endDateFmt,
      opens: 'left',
      locale: constants.datePickerLocale
    }, function (start, end, label) {
      $('#divModeButtons button.btn-success').click()
      // $(this.$el).changeFilter('date', start.format('DD-MM-YYYY'), end.format('DD-MM-YYYY'))
    })

    $('#divModeButtons button.btn-success').click()
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    ...mapActions([
      'setFilterDate',
      'setFilterClient'
    ]),
    getClass (mode) {
      let classVal = 'btn btn-sm btn-'
      classVal += this.dashboardFilter.mode === mode ? 'success' : 'default'
      return classVal
    },
    onAccountSelect (account) {
      this.setFilterClient(account)
      this.$parent.filterRefresh()
    },
    onModeSelect (mode) {
      document.activeElement.blur()
      this.changeFilter(mode)
    },
    changeFilter (mode) {
      let startDate, endDate, startDateFmt, endDateFmt
      let curentDate = moment()

      switch (mode) {
        case constants.dashboardFilterModes.today:
          startDate = curentDate.format('YYYYMMDD')
          endDate = curentDate.format('YYYYMMDD')
          startDateFmt = curentDate.format('DD/MM/YYYY')
          endDateFmt = curentDate.format('DD/MM/YYYY')
          break
        case constants.dashboardFilterModes.week:
          startDate = curentDate.startOf('isoWeek').format('YYYYMMDD')
          endDate = curentDate.endOf('isoWeek').format('YYYYMMDD')
          startDateFmt = curentDate.startOf('isoWeek').format('DD/MM/YYYY')
          endDateFmt = curentDate.endOf('isoWeek').format('DD/MM/YYYY')
          break
        case constants.dashboardFilterModes.month:
          startDate = curentDate.startOf('month').format('YYYYMMDD')
          endDate = curentDate.endOf('month').format('YYYYMMDD')
          startDateFmt = curentDate.startOf('month').format('DD/MM/YYYY')
          endDateFmt = curentDate.endOf('month').format('DD/MM/YYYY')
          break
        case constants.dashboardFilterModes.date:
          startDate = $('#dtDateRange').data('daterangepicker').startDate.format('YYYYMMDD')
          endDate = $('#dtDateRange').data('daterangepicker').endDate.format('YYYYMMDD')
          startDateFmt = $('#dtDateRange').data('daterangepicker').startDate.format('DD/MM/YYYY')
          endDateFmt = $('#dtDateRange').data('daterangepicker').endDate.format('DD/MM/YYYY')
          break
      }

      let dateFilter = {
        mode: mode || this.dashboardFilter.mode,
        startDate: startDate || this.dashboardFilter.startDate,
        endDate: endDate || this.dashboardFilter.endDate,
        startDateFmt: startDateFmt || this.dashboardFilter.startDateFmt,
        endDateFmt: endDateFmt || this.dashboardFilter.endDateFmt
      }

      this.setFilterDate(dateFilter)
      this.$parent.filterRefresh()
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style>

#divModeButtons {
  width: 100%;
}

#divModeButtons button {
  width: 25%;
  height:34px;
}

#dtDateRange {
  width: 100%;
  height:34px;
  z-index: auto;
}

#divDashAccountSelect .multiselect{
  width: 60% !important;
}

@media screen and (max-width: 1270px) {
  #divDashAccountSelect .multiselect{
    width: 70% !important;
  }
}

@media screen and (max-width: 990px) {
  #divDashAccountSelect .multiselect{
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// DashboardFilter.vue?1f045c4d